import React from 'react';

export default (props) => (
  <svg {...props} width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.82228 0.23646C6.07805 0.529681 6.05502 0.981316 5.77082 1.24521L1.7272 5L5.77082 8.75479C6.05502 9.01868 6.07805 9.47032 5.82228 9.76354C5.5665 10.0568 5.12876 10.0805 4.84456 9.81663L0.229178 5.53092C0.0832994 5.39547 0 5.20249 0 5C0 4.79751 0.0832994 4.60454 0.229178 4.46908L4.84456 0.183367C5.12876 -0.0805317 5.5665 -0.0567615 5.82228 0.23646Z" fill="#0486FE" />
  </svg>
);
